// FundUtilisationDetails.js
import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../config";
import * as XLSX from "xlsx";
// import { useLocation } from "react-router-dom";

export default function FundUtilisationDetails() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [schools, setSchools] = useState([]);
  const [districtName, setDistrictName] = useState(""); // ⭐ NEW

  // const params = new URLSearchParams(window.location.search);
  // const district = params.get("district");
  // const fy = params.get("fy");
  const location = useLocation();
  const district = location.state?.district;
  const fy = location.state?.fy;

  // Redirect if user directly opens URL or refreshes (no state available)
  useEffect(() => {
    if (!district || !fy) {
      navigate("/FundAlocation");
    }
  }, [district, fy, navigate]);


  // Convert FY → start & end dates
  const getFYDates = (fy) => {
    const [s, e] = fy.split("-");
    return { fy_start: `${s}-04-01`, fy_end: `${e}-03-31` };
  };

  const handleExportToExcel = () => {
    const excelData = schools.map((s) => ({
      School: s.school,
      Allocation: s.allocation,
      Utilisation: s.utilisation,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Fund Utilisation");
  
    const filename = `Fund_Utilisation_${districtName}_${fy}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };
  

  const { fy_start, fy_end } = getFYDates(fy);

  // ⭐ Fetch district name using master district API
  useEffect(() => {
    axios.get(`${API_BASE}/districts`).then((res) => {
      const found = res.data.find((d) => d.dist_id == district);
      if (found) setDistrictName(found.district);
    });
  }, [district]);

  // Fetch utilisation details
  const loadDetails = async () => {
    try {
      const res = await axios.get(`${API_BASE}/fund-utilisation-details`, {
        params: { district, fy_start, fy_end },
      });

      setSummary(res.data);
      setSchools(res.data.schools);
    } catch (err) {
      console.error("Error fetching utilisation:", err);
    }
  };

  useEffect(() => {
    loadDetails();
  }, []);

  if (!summary) return <p>Loading...</p>;

  // Chart data mapping
  const chartData = schools.map((s) => ({
    school: s.school,
    Allocation: s.allocation,
    Utilisation: s.utilisation,
  }));

  return (
    <div style={{ padding: 24 }}>
      <h2>
        Allocation vs Utilisation — School Wise
        <button
          onClick={() => navigate("/FundAlocation")}
          style={{
            padding: "10px 18px",
            background: "#9e2c2c",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            float: "right",
          }}
        >
          Back
        </button>
      </h2>

      {/* ⭐ UPDATED HEADING */}
      <h3>
        District: <span style={{ color: "green", fontWeight: "bold" }}>{districtName}</span>
        {" "} | FY: <span style={{ color: "blue" }}>{fy}</span>
      </h3>

      {/* Summary Cards */}
      <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
        <div
          style={{
            background: "#4caf50",
            padding: 20,
            borderRadius: 8,
            flex: 1,
            color: "#fff",
          }}
        >
          <h3>Total Allocation</h3>
          <h2>₹{summary.total_allocation.toLocaleString()}</h2>
        </div>

        <div
          style={{
            background: "#1976d2",
            padding: 20,
            borderRadius: 8,
            flex: 1,
            color: "#fff",
          }}
        >
          <h3>Total Utilisation</h3>
          <h2>₹{summary.total_utilisation.toLocaleString()}</h2>
        </div>

        <div
          style={{
            background: "#ff9800",
            padding: 20,
            borderRadius: 8,
            flex: 1,
            color: "#fff",
          }}
        >
          <h3>Balance</h3>
          <h2>₹{summary.balance.toLocaleString()}</h2>
        </div>
      </div>

      {/* Bar Chart */}
      <div
        style={{
          height: 500,
          background: "#fff",
          padding: 20,
          borderRadius: 8,
        }}
      >
        <ResponsiveBar
          data={chartData}
          keys={["Allocation", "Utilisation"]}
          indexBy="school"
          margin={{ top: 40, right: 80, bottom: 120, left: 100 }}
          padding={0.3}
          groupMode="grouped"
          colors={["#4caf50", "#1976d2"]}
          axisBottom={{ tickRotation: -40 }}
          enableLabel={true}
          label={(bar) => `₹${Number(bar.value).toLocaleString()}`}
          labelTextColor="#fff"
        />
      </div>
<div style={{display:"flex",justifyContent:"space-between"}}>
      {/* School Table */}
      <h3 style={{ marginTop: 30 }}>
        School-wise Allocation & Utilisation
      </h3>
      <div style={{ marginTop: 20, marginBottom: 10 }}>
  <button
    onClick={handleExportToExcel}
    style={{
      padding: "10px 16px",
      background: "rgb(46, 125, 50)",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    ⬇ Export to Excel
  </button>
  </div>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: 10,
        }}
      >
        <thead>
          <tr style={{ background: "#283593", color: "#fff", textAlign: "left" }}>
            <th style={{ padding: 10 }}>School</th>
            <th style={{ padding: 10 }}>Allocation</th>
            <th style={{ padding: 10 }}>Utilisation</th>
          </tr>
        </thead>
        <tbody>
          {schools.map((s) => (
            <tr key={s.id}>
              <td style={{ padding: 10 }}>{s.school}</td>
              <td style={{ padding: 10 }}>₹{s.allocation.toLocaleString()}</td>
              <td
                style={{
                  padding: 10,
                  color: s.utilisation > 0 ? "green" : "red",
                }}
              >
                ₹{s.utilisation.toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
